import {
  HStack,
  Image,
  SimpleGrid,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useScreenWidth from "../lib/useScreenWidth";

interface Props extends StackProps {
  children?: any;
  breakpoint: number;
}

export const BaseAuth = ({ children, breakpoint, ...props }: Props) => {
  const [imgPath, setImgPath] = useState<string>(
    "/assets/svg/illustration_login_buyer.svg"
  );
  const [titleText, setTitleText] = useState<string>(
    "Masuk dan Lanjutkan Belanja"
  );
  const [welcomeText, setWelcomeText] = useState<string>(
    "Belanja mudah dan aman langsung dari para UMKM terbaik! Temukan berbagai produk berkualitas dengan harga terbaik dan dukungan Reseller terpercaya."
  );
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const loginType = queryParams.get("type") || "";
  const sw = useScreenWidth();

  useEffect(() => {
    if (loginType === "reseller") {
      setTitleText("Masuk dan Mulai Jualanmu Sekarang");
      setImgPath("/assets/svg/illustration_login_reseller.svg");
      setWelcomeText(
        "Mau bisnis tanpa modal besar? Jadi reseller di BisnisLink.id! Pilih produk, jual dengan bebas, dan nikmati komisi menguntungkan dari setiap transaksi."
      );
    } else if (loginType === "supplier") {
      setTitleText("Masuk dan Tingkatkan Penjualanmu");
      setImgPath("/assets/svg/illustration_login_supplier.svg");
      setWelcomeText(
        "Tingkatkan penjualan produkmu tanpa repot! Gabung sebagai supplier di BisnisLink.id dan biarkan jaringan reseller memasarkan produkmu ke lebih banyak pelanggan."
      );
    } else if (location?.pathname === "/register") {
      setTitleText("Gabung Sekarang & Mulai Bisnis dengan Mudah");
      setImgPath("/assets/svg/illustration_register.svg");
      setWelcomeText(
        "Gabung dengan BisnisLink dan dapatkan akses produk berkualitas langsung dari Produsen. Tanpa stok, tanpa ribet, langsung cuan!"
      );
    }
  }, [location?.pathname, loginType]);

  return (
    <VStack
      className="base-auth"
      w={"100%"}
      h={"100vh"}
      overflow={"clip"}
      overflowY={"auto"}
    >
      <SimpleGrid
        columns={sw > breakpoint ? 2 : 1}
        spacing={sw > breakpoint ? 0 : 4}
        w={"100%"}
        h={sw > breakpoint ? "100%" : "fit-content"}
        className="simplegrid"
        p={4}
      >
        <VStack
          bgColor={"red.400"}
          p={10}
          borderRadius={"xl"}
          justify={"center"}
          textAlign={"center"}
        >
          <HStack
            className="wrap-logo"
            onClick={() => navigate("/")}
            cursor={"pointer"}
          >
            <Image src="/logo.png" w={"100%"} maxW={"28px"} alt="Base Auth" />

            <Text fontWeight={"bold"} fontSize={[16, null, 18]} color={"white"}>
              BisnisLink
            </Text>
          </HStack>

          <Text
            fontWeight={"bold"}
            fontSize={[20, null, 22]}
            mt={4}
            color={"white"}
            textAlign={"center"}
          >
            {titleText}
          </Text>

          <Text fontSize={[12, null, 12]} mt={2} color={"white"}>
            {welcomeText}
          </Text>

          {sw > breakpoint && (
            <Image
              src={imgPath}
              mt={8}
              w={"100%"}
              alt="Business"
              maxW={sw > breakpoint ? "400px" : "200px"}
            />
          )}
        </VStack>

        <Outlet />
      </SimpleGrid>
    </VStack>
  );
};
